import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/AdminSidebar";
import "../../content/styles/admin-paginas.css";

const AdminPagesLayout = () => {
  return (
    <div className="landing-container">
      <div className="admin-pages-grid">
        <AdminSidebar />
        <div className="flex-1">
            <div style={{ maxHeight: "calc(100vh - 100px)", overflow: "auto" }}>
              <section className="admin-pages-form">
                <Outlet />
              </section>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPagesLayout;
